import './create.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import { Tabs, Pane  } from '../shared/tabs';

import EditForm from './components/form';
import Permissions from './components/permissions/main';
import MonthlyProductivity from './components/monthly-productivity';
import { selectors as rootSelectors } from '../root';
import CsvUpload from '../shared/form-elements/csv-upload';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content admins-create">
			<div className="container__content-title clearfix">
				<div className="container__content-title-position">
					<Link to='admins/' className="link">{ props.intl('Return to list of admins') }</Link>
				</div>
				<div className="container__content-title-position">
					<h2 className="title">{ props.intl('Edit admin') }</h2>
				</div>
			</div>
			<div className="container__content-body">
				<div className="form-container">
					<div className="form-container__head">
						<h2 className="title icon-edit">{ props.intl('Edit admin') }</h2>
						<span className="item-title">{props.getAdminFieldsById(props.params.id)['email']}</span>
					</div>
					<Tabs selected={props.currentTab} onChangeTab={props.changeTab}>
						<Pane label={props.intl('Main')} index="main">
							<EditForm {...props} initialValues={props.getAdminFieldsById(props.params.id)} editId={props.params.id} />
						</Pane>
						<Pane label={props.intl('Permissions')} index="permissions">
							<Permissions {...props} />
						</Pane>
						<Pane label={props.intl('Monthly productivity')} index="monthly-productivity">
							<MonthlyProductivity {...props} initialValues={props.monthlyProductivityInitialData} />
							<div>
								<form onSubmit={props.sendFile.bind(null, props.params.id)}>
									<div className="upload-description">
										<p>
											Productivity file must be csv.
										</p>
										<p>
											Columns:
											<b>
												admin_id, country_code, start, desired_real_approves_count,
												desired_profit_usd, affiliates_plan
											</b>
										</p>
									</div>
									<div className="display-flex">
										<CsvUpload {...props}/>
										<button className="ui-btn ui-btn-primary">Send</button>
									</div>
								</form>
							</div>
						</Pane>
					</Tabs>
				</div>
			</div>
		</div>
	</Animate>
), 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		admins: selectors.getAdmins(state),
		monthlyProductivityInitialData: selectors.getMonthlyProductivityInitialData(state),
		langSelectOptions: selectors.getLangSelectOptions(state),
		adminRoles: selectors.getAdminRoles(state),
		permissionsSelectOptions: selectors.getPermissionsSelectOptions(state),
		timezoneOptions: selectors.getTimezoneOptions(state),
		progressBar: selectors.getProgressBar(state),
		getAdminFieldsById: selectors.getAdminFieldsById(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		error: selectors.getError(state),
		can: selectors.getCan(state),
		intl: selectors.getIntl(state),
		currentTab: selectors.getCurrentTab(state),
		permissionsList: selectors.getPermissionsList(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/edit.js